import LoginPage from 'Placements/Components/Login/index'
import ChooseLanguage from 'Placements/Pages/ChooseLanguage.page'
import ServerErrorPage from 'Placements/Pages/ServerError.page'
import PageNotFoundPage from 'Placements/Pages/PageNotFound.page'
import ForgotPassword from 'Placements/Pages/ForgotPassword.page'
import ResetPassword from 'Placements/Pages/ResetPassword.page'
import RegisterUser from "Placements/Pages/RegisterUser.page"
import Welcome from 'Placements/Pages/Welcome.page'
import ChooseSchool from 'Placements/Pages/ChooseSchool.page'
import Test from 'Placements/Pages/Test.page'
import FinalReport from 'Placements/Pages/FinalReport.page'
import PartialReport from 'Placements/Pages/PartialReport.page'
import TestList from "Placements/Pages/TestList.page";
import TestListDetails from "Placements/Pages/TestListDetails.page";
import ExerciseAnswered from "Placements/Pages/ExerciseAnswered.page";
import Waiting from 'Placements/Pages/Waiting.page'

export default [
    {
        keystone: 'LOGIN',
        path: '/login',
        label: 'LoginPage',
        page: LoginPage,
        disableHeader: true,
    },
    {
        keystone: 'REGISTER_USER',
        path: '/register-user',
        label: 'register-user',
        page: RegisterUser,
        disableHeader: true,
    },
    {
        keystone: 'FORGOT_PASSWORD',
        path: '/forgot-password',
        label: 'ForgotPassword',
        page: ForgotPassword,
        disableHeader: true,
    },
    {
        keystone: 'RESET_PASSWORD',
        path: '/redefine-senha/:hash/:id_Usuario',
        label: 'ResetPassword',
        page: ResetPassword,
        disableHeader: true,
    }, 
    {
        keystone: 'WELCOME',
        path: '/welcome',
        label: 'Welcome',
        page: Welcome,
        disableHeader: true,
    }, 
    {
        keystone: 'CHOOSE_SCHOOL',
        path: '/choose-school',
        label: 'ChooseSchool',
        page: ChooseSchool,
        disableHeader: true,
    }, 
    {
        keystone: 'LANGUAGE',
        path: '/choose-language',
        label: 'ChooseLanguage',
        page: ChooseLanguage,
    },
    {
        keystone: 'FINAL_REPORT',
        path: '/test/final-report',
        label: 'FinalReport',
        page: FinalReport,
    },
    {
        keystone: 'PARTIAL_REPORT',
        path: '/test/partial-report',
        label: 'PartialReport',
        page: PartialReport,
    },
    {
        keystone: 'TEST',
        path: '/test',
        label: 'Test',
        page: Test,
    },
    {
        keystone: 'TEST_LIST_DETAILS',
        path: '/admin/test-list/:idTesteUser',
        label: 'TestListDetails',
        page: TestListDetails,
    },
    {
        keystone: 'TEST_LIST',
        path: '/admin/test-list',
        label: 'TestList',
        page: TestList,
    },
    {
        keystone: 'EXERCISE_ANSWERED',
        path: '/admin/exercise-answered/:testeParte/:idExercice',
        label: 'ExerciseAnswered',
        page: ExerciseAnswered,
    },
    {
        keystone: 'EXERCISES_ANSWERED',
        path: '/admin/exercise-answered/:testeParte',
        label: 'ExerciseAnswered',
        page: ExerciseAnswered,
    },
    {
        keystone: 'WAITING',
        path: '/waiting',
        label: 'Waiting',
        page:  Waiting,
        disableHeader: true,
    },
    {
        keystone: 'SERVER_ERROR',
        path: '/server-error',
        label: 'SserverError',
        page: ServerErrorPage
    },
    {
        keystone: "PAGE_NOT_FOUND",
        label: 'PageNotFound',
        page: PageNotFoundPage
    },
]